import { createActionType, createAction } from '../shared/helpers/redux';

const prefix = 'Popup';
export const ActionTypes = {
    fetchSystemNotification: createActionType('fetchSystemNotification')(prefix),
    fetchSystemNotificationCompleted: createActionType('fetchSystemNotificationCompleted')(prefix),
    updateSystemNotification: createActionType('updateSystemNotificationInfo')(prefix),
    updateSystemNotificationCompleted: createActionType('updateSystemNotificationCompleted')(prefix)
};

export const fetchSystemNotification = createAction(ActionTypes.fetchSystemNotification);
export const fetchSystemNotificationCompleted = (displaySystemNotificationPopup) => createAction(ActionTypes.fetchSystemNotificationCompleted)({ payload: { displaySystemNotificationPopup } });
export const updateSystemNotification = createAction(ActionTypes.updateSystemNotification);
export const updateSystemNotificationCompleted = (displaySystemNotificationPopup) => createAction(ActionTypes.updateSystemNotificationCompleted)({ payload: { displaySystemNotificationPopup } });